import { render, staticRenderFns } from "./TicketInformation.vue?vue&type=template&id=6181240d&scoped=true"
import script from "./TicketInformation.vue?vue&type=script&lang=js"
export * from "./TicketInformation.vue?vue&type=script&lang=js"
import style0 from "./TicketInformation.vue?vue&type=style&index=0&id=6181240d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6181240d",
  null
  
)

export default component.exports